var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"iframe",staticStyle:{"width":"100%"},style:({ height: _vm.iframeHeight + 'px' }),attrs:{"frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }